import { render, staticRenderFns } from "./CheckRoles.vue?vue&type=template&id=2d7c75de"
import script from "./CheckRoles.vue?vue&type=script&lang=js"
export * from "./CheckRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports